export default __webpack_public_path__ + "static/image1-e6ff720b33d51d9d71ba92034e613cdc.png";